import { Button, Dialog, DialogContent } from '@mui/material';

interface Props {
    onExit: Function;
    open: boolean;
    text: string;
}


export default function AlertModal(props: Props) {
    const { text } = props;

    const handleClose = () => {
        props.onExit();
    };

    return (
        <Dialog
            onClose={handleClose}
            open={props.open}
            PaperProps={{
                style: {
                    backgroundColor: '#ffffff',
                    borderRadius: 8,
                    width: 400
                },
            }}
        >
            <DialogContent>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    <p>{text}</p>
                    <Button style={{
                        height: 35,
                        width: 120,
                        alignSelf: 'center',
                        borderRadius: 20,
                        marginTop: 20,
                        marginBottom: 20,
                        backgroundColor: '#004B9E',
                        color: 'white',
                        fontWeight: 'bold'
                    }}
                        onClick={handleClose}
                    >
                        Aceptar
                    </Button>
                </div>
            </DialogContent>
        </Dialog >
    );
}